  <div style="display: flex; flex-direction: column; height: 400px">
    <div class="ignore-darkreader" id='{{chartId}}' style="flex: 1;">
      <ng-container *ngIf="noDataAvailable">
        <div class="no-data-available">No data available.</div>
      </ng-container>
    </div>

    <div class="ivol-view ivol-view-new">{{locale.iVolView}}</div>
  </div>
